import { Provider } from '@angular/core';
import { ERP_API_URL, resolveErpApiUrl } from './erp-api.tokens';

export function provideErpApi(apiUrl: string): Provider[] {
  return [{ provide: ERP_API_URL, useValue: resolveErpApiUrl(apiUrl) }];
}
